import React from 'react';
import { TopBar } from './components/TopBar';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FeaturesSection } from './components/FeaturesSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TrustSection } from './components/TrustSection';
import { ProductSection } from './components/ProductSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-0">
      <TopBar data-id="element-1" />
      <Header data-id="element-2" />
      <HeroSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <FeaturesSection data-id="element-5" />
      <ComparisonSection data-id="element-6" />
      <TrustSection data-id="element-7" />
      <ProductSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <FaqSection data-id="element-10" />
      <CtaSection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}